import { SubAPI } from "./SubAPI";
export class Payables extends SubAPI {
    list(props) { return this.fetcher.get("/api/payables", props); }
    get(props) { return this.fetcher.get("/api/payable", props); }
    upsert(input) { return this.fetcher.post("/api/payable", input); }
    listItems(props) { return this.fetcher.get("/api/payable/items", props); }
    upsertItem(input) { return this.fetcher.post("/api/payable/item", input); }
    setPoLinks(input) { return this.fetcher.post("/api/payable/set-po-links", input); }
    removeAttachment(input) { return this.fetcher.post("/api/payable/remove-attachment", input); }
    uploadAttachment(input) { return this.fetcher.postFormData("/api/payable/upload-attachment", { id: input.id.toString(), file: input.file }); }
    approve(input) { return this.fetcher.post("/api/payable/approve", input); }
    quickbooksSync(input) { return this.fetcher.post("/api/payable/quickbooks-sync", input); }
}
